var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.703 12.594c2.18 0 3.86-1.485 3.86-3.43 0-1.523-.829-2.883-2.391-3.39C17.289 2.46 14.953 0 11.969 0c-2.14 0-3.563 1.188-4.344 2.633-1.797-.75-3.86.703-3.836 2.797C2.125 5.555 1 6.953 1 8.758c0 2.156 1.828 3.82 4.266 3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEAEB2",
    strokeWidth: 0.2,
    d: "m17.072 5.77-.003.075.072.024c1.516.492 2.322 1.81 2.322 3.295 0 1.88-1.624 3.33-3.76 3.33l-10.437-.016c-2.393 0-4.166-1.629-4.166-3.72 0-1.763 1.095-3.108 2.697-3.229l.093-.007V5.43c-.024-2.03 1.973-3.423 3.696-2.704l.084.035.043-.08C8.48 1.26 9.872.1 11.969.1c2.923 0 5.218 2.409 5.103 5.67Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__a",
    width: 19.063,
    height: 13.094,
    x: 0.75,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgCloud;